(function(){
  function randInt(min, max){ return Math.floor(Math.random()*(max-min+1))+min; }

  function renderOne(el){
    var min = parseInt(el.getAttribute('data-min') || 6, 10);
    var max = parseInt(el.getAttribute('data-max') || 30, 10);
    if (min > max) { var t = min; min = max; max = t; }

    var n = randInt(min, max);
    var eyeUrl = (window.NN_SOCIAL_PROOF && window.NN_SOCIAL_PROOF.eyeUrl) || '';
    var text = n + ' visiteurs consultent actuellement ce produit.';

    el.innerHTML =
      '<span class="nn-social-proof">' +
        (eyeUrl ? '<img class="nn-eye" src="'+ eyeUrl +'" alt="œil" />' : '') +
        '<span>'+ text +'</span>' +
      '</span>';
  }

  function init(){
    document.querySelectorAll('.js-social-proof').forEach(renderOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
